import classNames from "classnames";
import React from "react";
import orders from "../../data/orders";
import { Effects } from "../Card";
import { cardImageForBuilding } from "../card-images";
import "./OpenHand.css";

function Card({ card }) {
  const order = orders[card.name];
  return (
    <div className={classNames("mini-Card", cardImageForBuilding(card.name))}>
      {order && (
        <div className="effects">
          <Effects order={order} />
        </div>
      )}
    </div>
  );
}

function OpenHand({ cards }) {
  if (!cards?.length) {
    return null;
  } else {
    return (
      <div className="mini-OpenHand">
        {cards.map((card, index) => (
          <Card
            key={(card.deck ?? "") + (card.id ?? index)}
            card={card}
          />
        ))}
      </div>
    );
  }
}

export default OpenHand;
